export interface RoutesInterface {
  login: string;
  userSessionInfo: string;
  reports: string;
  domain: string;
  FAQ: string;
  userFeedback: string;
  tour: string;
}

const routes: RoutesInterface = {
  login: "/csg-sa-ms-login-rmkt-ecs/mfa/",
  userSessionInfo: "/csg-sa-ms-rmarketplace-ecs/profile/",
  reports: "/csg-sa-ms-rmarketplace-ecs/report/",
  domain: "/csg-sa-ms-rmarketplace-ecs/domain/",
  FAQ: "/csg-sa-ms-rmarketplace-ecs/faq/",
  userFeedback: "/csg-sa-ms-rmarketplace-ecs/feedback/",
  tour: "/csg-sa-ms-rmarketplace-ecs/tour/",
};

export default routes;
